import { prop, arrayToObject, round } from '../../utilities';
import { getCategoryIdsFromProduct } from '../../utilities/selectors';

function isSpojMatOrPreDrev(data) {
  let productCategoryIds = getCategoryIdsFromProduct(data);
  productCategoryIds.push(prop(data, 'category_number', ''));

  productCategoryIds = productCategoryIds.filter(a => a);

  if (productCategoryIds.length) {
    const isSpojOrDrev =
      isCategory(productCategoryIds, 'SPOJ_MATERIAL') ||
      isCategory(productCategoryIds, 'PRE_DREVAROV');

    return isSpojOrDrev;
  } else {
    const categoryNames: string[] = prop(data, 'categories_names', []);
    if (categoryNames && categoryNames.length) {
      return (
        categoryNames.includes('Spojovací materiál') ||
        categoryNames.includes('Pre drevárov')
      );
    }
  }
  return false;
}

function resolveIsVykurovaciaOrPletiva(data) {
  let productCategoryIds = getCategoryIdsFromProduct(data);
  productCategoryIds.push(prop(data, 'category_number', ''));

  productCategoryIds = productCategoryIds.filter(a => a);
  if (productCategoryIds.length) {
    return (
      isCategory(productCategoryIds, 'CENTRUM_VYKUROV') ||
      isCategory(productCategoryIds, 'PLETIVA')
    );
  } else {
    const categoryNames: string[] = prop(data, 'categories_names', []);
    if (categoryNames && categoryNames.length) {
      return (
        categoryNames.includes('Vykurovacia technika') ||
        categoryNames.includes('Pletivá a oplotenia')
      );
    }
  }
  return false;
}

function getZemplinProductDefaultInfo(product, goodName = 'main_good') {
  const unit = prop(product, `${goodName}.units`) || 'ks';
  const heliosUnit = prop(product, `${goodName}.helios_units`);
  const correctUnit = heliosUnit || unit;
  const isMks = correctUnit === 'Mks';

  const storesInfo = prop(product, `${goodName}.stores_info`, null);

  const storesInfoObj = storesInfo
    ? arrayToObject(storesInfo, 'store_id')
    : null;

  const correctZemplinCountInternal = storesInfoObj
    ? prop(storesInfoObj, 'internal.quantity')
    : null;

  const correctZemplinCountExternal = storesInfoObj
    ? prop(storesInfoObj, 'external.quantity')
    : null;

  const onStockCountInternal = correctZemplinCountInternal
    ? correctZemplinCountInternal
    : 0;

  const onStockCountExternal = correctZemplinCountExternal
    ? correctZemplinCountExternal
    : 0;

  const correctCountInternal = isMks
    ? onStockCountInternal / 1000
    : onStockCountInternal;

  const correctCountExternal = isMks
    ? onStockCountExternal / 1000
    : onStockCountExternal;

  const customOrderNrs = prop(product, `${goodName}.custom_order_nr`, ['']);
  const orderNr = customOrderNrs
    ? customOrderNrs[customOrderNrs.length - 1]
    : '';

  const productPackages = prop(product, 'productPackages', []);

  const minQuantity = prop(product, `${goodName}.order_quantity_min`);

  const correctPackageNumber = minQuantity
    ? isMks
      ? minQuantity / 1000
      : minQuantity
    : getCorrectPackageNumber(productPackages, isMks);

  const b2bDiscount = prop(product, `${goodName}.b2b_discount`, null);

  const assembling = prop(product, 'assembling');
  const showServis = prop(product, 'servis');
  const showServisMax = prop(product, 'servis_max');

  const customerDiscount = prop(product, `${goodName}.customer_discount`);

  const price = prop(product, `${goodName}.final_price`);
  const oldPrice = prop(product, `${goodName}.oldprice`);
  const priceWithoutVat = prop(product, `${goodName}.final_price_without_vat`);
  const correctPrice = price
    ? isMks
      ? round(1000 * price, 6).toString()
      : round(price, 6).toString()
    : '';
  const correctOldPrice = oldPrice
    ? isMks
      ? round(1000 * oldPrice, 6).toString()
      : round(oldPrice, 6).toString()
    : '';
  const correctPriceWithoutVat = priceWithoutVat
    ? isMks
      ? round(1000 * priceWithoutVat, 6).toString()
      : round(priceWithoutVat, 6).toString()
    : '';

  const mocPrice = prop(product, `${goodName}.moc_price`);

  const unpackingCost = prop(product, `${goodName}.sum_unpacking_cost`);
  const unpackingCostWithoutVat = prop(
    product,
    `${goodName}.sum_unpacking_cost_without_vat`,
  );
  const isSpojMat = isSpojMatOrPreDrev(product);
  const isVykurovaciaOrPletiva = resolveIsVykurovaciaOrPletiva(product);

  const showB2C = prop(product, 'status_b2c') ? false : true;
  const showB2B = prop(product, 'status_b2b') ? false : true;
  const statusB2C = prop(product, 'status_b2c', 0);
  const statusB2B = prop(product, 'status_b2b', 0);
  const freeDelivery = prop(product, 'free_delivery', false);

  const specialDiscountPcn = prop(product, `${goodName}.special_discount_pcn`);
  const specialDiscount = prop(product, `${goodName}.special_discount`);
  const specialDiscountWithoutVat = prop(
    product,
    `${goodName}.special_discount_without_vat`,
  );
  const customerDiscountPcn = prop(
    product,
    `${goodName}.customer_discount_pcn`,
  );

  const priceForUnpacking = prop(product, `${goodName}.price_for_unpacking`);

  const customerPrices = prop(product, `${goodName}.customer_prices`);
  const salePercentage = prop(product, `${goodName}.sale_percentage`);
  const defaultPackageSize = prop(product, 'default_package_size', '');
  const wholePackagesOnly = prop(product, 'whole_packages_only', '');
  const boxQuantity = prop(product, `${goodName}.box_quantity`);

  return {
    salePercentage,
    priceForUnpacking,
    freeDelivery,
    unit: correctUnit,
    onStock: correctCountInternal,
    onStockExternal: correctCountExternal,
    price: correctPrice,
    priceWithoutVat: correctPriceWithoutVat,
    oldPrice: correctOldPrice,
    assembling,
    orderNr,
    productPackages: correctPackageNumber,
    defaultPackageSize,
    wholePackagesOnly,
    priceForPiece: priceWithoutVat,
    customerDiscount: customerDiscount
      ? round(customerDiscount, 2).toString()
      : '',
    mocPrice: mocPrice ? round(mocPrice, 2).toString() : '',
    b2bDiscount,
    unpackingCost,
    unpackingCostWithoutVat,
    storesInfo,
    isSpojMat,
    isVykurovaciaOrPletiva,
    showB2C,
    showB2B,
    statusB2C,
    statusB2B,
    customerDiscountPcn,
    specialDiscountPcn,
    specialDiscount: specialDiscount
      ? isMks
        ? round(specialDiscount * 1000, 2)
        : round(specialDiscount, 2)
      : '',
    specialDiscountWithoutVat: specialDiscountWithoutVat
      ? isMks
        ? round(specialDiscountWithoutVat * 1000, 2)
        : round(specialDiscountWithoutVat, 2)
      : '',
    customerPrices,
    isMks,
    qtyDiscounts: prop(product, 'qty_discounts', []),
    showServis,
    showServisMax,
    boxQuantity,
  };
}

const getElasticCategoryZemplinProductInfo = (product, isB2B) => {
  const unit = prop(product, 'helios_units')
    ? prop(product, 'helios_units')
    : 'ks';
  const isMks = unit === 'Mks';

  const storesInfo = prop(product, `stores_info`, null);
  const storesInfoObj = storesInfo
    ? arrayToObject(storesInfo, 'store_id')
    : null;

  const correctZemplinCountInternal = storesInfoObj
    ? prop(storesInfoObj, 'internal.quantity')
    : null;

  const correctZemplinCountExternal = storesInfoObj
    ? prop(storesInfoObj, 'external.quantity')
    : null;

  const onStockCountInternal = correctZemplinCountInternal
    ? correctZemplinCountInternal
    : 0;

  const onStockCountExternal = correctZemplinCountExternal
    ? correctZemplinCountExternal
    : 0;

  const correctCountInternal = isMks
    ? onStockCountInternal / 1000
    : onStockCountInternal;
  const correctCountExternal = isMks
    ? onStockCountExternal / 1000
    : onStockCountExternal;

  const price = prop(product, `product_detail.main_good.final_price`);
  const priceWithoutVat = prop(
    product,
    `product_detail.main_good.final_price_without_vat`,
  );

  const correctPrice = price
    ? isMks
      ? (1000 * price).toFixed(6)
      : price.toFixed(6)
    : '';

  const correctPriceWithoutVat = priceWithoutVat
    ? isMks
      ? (1000 * priceWithoutVat).toFixed(6)
      : priceWithoutVat.toFixed(6)
    : '';

  const productPackages = prop(product, `product_packages`);
  const goods = prop(product, `product_detail.goods`, []);
  const minQuantity = goods ? prop(goods[0], `order_quantity_min`, null) : null;
  const correctPackageNumber = minQuantity
    ? isMks
      ? minQuantity / 1000
      : minQuantity
    : getCorrectPackageNumber(productPackages, isMks);

  const unpackingCost = prop(
    product,
    `product_detail.main_good.sum_unpacking_cost`,
  );
  const unpackingCostWithoutVat = prop(
    product,
    `product_detail.main_good.sum_unpacking_cost_without_vat`,
  );

  const customOrderNrs = prop(
    product,
    'product_detail.main_good.custom_order_nr',
  );
  const customOrderNr =
    customOrderNrs && customOrderNrs[0] ? customOrderNrs : null;

  const isSpojMat = isSpojMatOrPreDrev(product);
  const isVykurovaciaOrPletiva = resolveIsVykurovaciaOrPletiva(product);

  const statusB2C = prop(product, 'status_b2c', 0);
  const statusB2B = prop(product, 'status_b2b', 0);
  const showB2C = prop(product, 'status_b2c') ? false : true;
  const showB2B = prop(product, 'status_b2b') ? false : true;
  const statusShowPrice = isB2B ? statusB2B !== 3 : statusB2C !== 3;
  const statusShowAddToCart = isB2B ? statusB2B === 0 : statusB2C === 0;

  const specialDiscountPcn = prop(
    product,
    `product_detail.main_good.special_discount_pcn`,
  );
  const specialDiscount = prop(
    product,
    `product_detail.main_good.special_discount`,
  );
  const specialDiscountWithoutVat = prop(
    product,
    `product_detail.main_good.special_discount_without_vat`,
  );
  const currency = prop(product, 'product_detail.main_good.currency.name', '')
    ? '€'
    : '€';
  const correctShownSpecialDiscount =
    specialDiscountPcn && specialDiscountPcn !== 0
      ? specialDiscountPcn
      : isB2B
      ? specialDiscountWithoutVat
      : specialDiscount;
  const correctShownSpecialDiscountText =
    correctShownSpecialDiscount && correctShownSpecialDiscount !== 0
      ? specialDiscountPcn && specialDiscountPcn
        ? `-${correctShownSpecialDiscount}%`
        : `${round(
            isMks
              ? correctShownSpecialDiscount * 1000
              : correctShownSpecialDiscount,
            2,
          )}${currency}`
      : '';
  const freeDelivery = prop(product, `product_detail.free_delivery`);
  const priceForUnpacking = prop(
    product,
    'product_detail.main_good.price_for_unpacking',
  );
  const customerPrices = prop(
    product,
    `product_detail.main_good.customer_prices`,
  );
  const defaultPackageSize = prop(
    product.product_detail,
    'default_package_size',
    '',
  );
  const wholePackagesOnly = prop(
    product.product_detail,
    'whole_packages_only',
    false,
  );

  return {
    priceForUnpacking,
    freeDelivery,
    onStock: correctCountInternal,
    onStockExternal: correctCountExternal,
    storesInfo,
    price: correctPrice,
    priceWithoutVat: correctPriceWithoutVat,
    unit,
    productPackages: correctPackageNumber,
    unpackingCost,
    unpackingCostWithoutVat,
    customOrderNr,
    isSpojMat,
    isVykurovaciaOrPletiva,
    showB2C,
    showB2B,
    statusShowPrice,
    statusShowAddToCart,
    specialDiscount: correctShownSpecialDiscountText,
    customerPrices,
    correctShownSpecialDiscount,
    defaultPackageSize,
    wholePackagesOnly,
  };
};

const getCountSetterColor = (
  onStock: number,
  isMks: boolean,
  step: number,
  count: any,
  trueOnStock: string,
): string => {
  let newOnStock = onStock;

  if (isMks) {
    newOnStock = onStock / 1000;
  }
  const minValueReminder = round((count * 10000) % (step * 10000), 1);
  const onStockReminder = round((newOnStock * 10000) % (step * 10000), 1);

  if (
    round(count * 10000, 1) % round(step * 10000, 1) !== 0 &&
    minValueReminder !== onStockReminder &&
    parseFloat(trueOnStock) !== parseFloat(count)
  ) {
    return '#FFA454';
  }
  return '';
};

const showWholePackagesOnlyWarning = (
  onStock: number,
  isMks: boolean,
  count: any,
  step: number,
  trueOnStock: string,
  wholePackagesOnly: boolean,
): boolean => {
  let newOnStock = onStock;

  if (isMks) {
    newOnStock = onStock / 1000;
  }
  const minValueReminder = round((count * 10000) % (step * 10000), 1);
  const onStockReminder = round((newOnStock * 10000) % (step * 10000), 1);

  if (
    (count * 10000) % (step * 10000) !== 0 &&
    minValueReminder !== onStockReminder &&
    parseFloat(trueOnStock) !== parseFloat(count) &&
    wholePackagesOnly
  ) {
    return true;
  }
  return false;
};

function getZemplinCartProductInfo(product) {
  const unit = prop(product, 'good.units') || 'ks';
  const heliosUnit = prop(product, 'good.helios_units');
  const correctUnit = heliosUnit || unit;
  const isMks = correctUnit === 'Mks';

  const productPackages = prop(product, 'product.productPackages', []);
  const defaultPackageSize = prop(product, 'default_package_size', '');
  const wholePackagesOnly = prop(product, 'whole_packages_only', '');
  const minQuantity = prop(product, `good.order_quantity_min`);

  const correctPackageNumber = minQuantity
    ? isMks
      ? minQuantity / 1000
      : minQuantity
    : getCorrectPackageNumber(productPackages, isMks);

  const count = prop(product, 'count');
  const correctCount = isMks ? count / 1000 : count;

  const unitPrice = prop(product, `good.unitprice`);

  const price = prop(product, `good.final_price`);
  const priceWithoutVat = prop(product, `good.final_price_without_vat`);
  const sumPrice = prop(product, `sum_price`);
  const sumPriceWithoutVat = prop(product, `sum_price_without_vat`);
  const finalPricePerUnitWithVat = prop(
    product,
    `final_price_per_unit_with_vat`,
  );
  const finalPricePerUnitWithoutVat = prop(
    product,
    `final_price_per_unit_without_vat`,
  );

  const correctPrice = price
    ? isMks
      ? (1000 * price).toFixed(6)
      : price.toFixed(6)
    : '';
  const correctPriceWithoutVat = priceWithoutVat
    ? isMks
      ? (1000 * priceWithoutVat).toFixed(6)
      : priceWithoutVat.toFixed(6)
    : '';
  const correctFinalPricePerUnitWithVat = finalPricePerUnitWithVat
    ? finalPricePerUnitWithVat.toFixed(6)
    : '';
  const correctFinalPricePerUnitWithoutVat = finalPricePerUnitWithoutVat
    ? finalPricePerUnitWithoutVat.toFixed(6)
    : '';

  const storesInfo = prop(product, `good.stores_info`, null);
  const storesInfoObj = storesInfo
    ? arrayToObject(storesInfo, 'store_id')
    : null;

  const correctZemplinCountInternal = storesInfoObj
    ? prop(storesInfoObj, 'internal.quantity')
    : null;

  const correctZemplinCountExternal = storesInfoObj
    ? prop(storesInfoObj, 'external.quantity')
    : null;

  const onStockCount = correctZemplinCountInternal
    ? correctZemplinCountInternal
    : prop(product, `good.on_stock_count`, 0);

  const onStockCountExternal = correctZemplinCountExternal;

  const b2BDiscount = prop(product, `good.b2b_discount`);
  const priceForUnpacking = prop(product, `unpacking_cost`);
  const boxQuantity = prop(product, 'good.box_quantity');

  const oldPrice = prop(product, `good.oldprice`);
  const correctOldPrice = oldPrice
    ? isMks
      ? round(1000 * oldPrice, 6).toString()
      : round(oldPrice, 6).toString()
    : '';

  return {
    priceForUnpacking,
    count: correctCount,
    unit: correctUnit,
    productPackages: correctPackageNumber,
    defaultPackageSize,
    wholePackagesOnly,
    price: correctPrice,
    priceWithoutVat: correctPriceWithoutVat,
    priceForPiece: price,
    priceForPieceWithoutVat: priceWithoutVat,
    sumPrice: sumPrice ? sumPrice : '',
    sumPriceWithoutVat: sumPriceWithoutVat ? sumPriceWithoutVat : '',
    onStock: onStockCount,
    onStockExternal: onStockCountExternal,
    storesInfo,
    finalPricePerUnitWithVat: correctFinalPricePerUnitWithVat,
    finalPricePerUnitWithoutVat: correctFinalPricePerUnitWithoutVat,
    b2BDiscount,
    unitPrice,
    boxQuantity,
    isSale: !!prop(product, 'product.is_sale'),
    isSaleB2B: !!prop(product, 'product.is_sale_b2b'),
    isSaleout: !!prop(product, 'product.issaleout'),
    oldPrice: correctOldPrice,
  };
}

function getZemplinCartSummaryInfo(cart) {
  const vatGroups = prop(cart, 'vat_groups', null);
  if (!vatGroups) {
    return {
      vatGroups: null,
    };
  }
  const vatGroup0Total = prop(vatGroups['0'], 'price_without_vat')
    ? +round(prop(vatGroups['0'], 'price_without_vat'), 2)
    : 0;
  const vatGroup0TotalWithDph = prop(vatGroups['0'], 'price')
    ? +round(prop(vatGroups['0'], 'price'), 2)
    : 0;
  const vatGroup20Total = prop(vatGroups['20'], 'price_without_vat')
    ? +round(prop(vatGroups['20'], 'price_without_vat'), 2)
    : 0;
  const vatGroup20TotalWithDph = prop(vatGroups['20'], 'price')
    ? +round(prop(vatGroups['20'], 'price'), 2)
    : 0;
  const vatGroup20TotalDph = vatGroup20TotalWithDph - vatGroup20Total;

  return {
    vatGroup0Total,
    vatGroup0TotalWithDph,
    vatGroup20Total,
    vatGroup20TotalWithDph,
    vatGroup20TotalDph: vatGroup20TotalDph ? round(vatGroup20TotalDph, 2) : 0,
  };
}

function getZemplinTrueCount(isMks: boolean, count: number) {
  if (isMks) {
    const decimals = round(count, 5)
      .toString()
      .split('.')[1];
    if (decimals && decimals.length > 3) {
      return round(count * 1000, 3);
    }
  }
  return isMks ? Math.round(count * 1000) : count;
}

function getZemplinTrueCountFromNormalCount(isMks: boolean, count: number) {
  return isMks ? count / 1000 : count;
}

function getCorrectPackageNumber(packages, isMks: boolean) {
  if (!packages || packages.length === 0) {
    return 0;
  }

  const packageNumbers = packages.map(p => p.type);
  const min = Math.min(...packageNumbers);

  return isMks ? min / 1000 : min;
}

function isOrderingLessThanMinimum(product) {
  const {
    count,
    productPackages,
    priceForUnpacking,
  } = getZemplinCartProductInfo(product);
  if (
    count < productPackages &&
    productPackages >= 0.026 &&
    priceForUnpacking &&
    priceForUnpacking * +count < 10
  ) {
    return true;
  }

  return false;
}

function getZemplinRequestDetailItemInfo(item) {
  const unit = prop(item, 'good_details_json.units');
  const heliosUnit = prop(item, 'good_details_json.heliosUnits');
  const correctUnit = heliosUnit || unit;
  const isMks = correctUnit === 'Mks';
  const quantity = prop(item, 'quantity');

  const correctCount = isMks ? quantity / 1000 : quantity;

  return {
    count: correctCount,
    unit: correctUnit,
  };
}

function shouldShowPriceIfNotOnStock(categoryIds: string[]) {
  return !categoryIds.includes('SPOJ_MATERIAL');
}

function isCategory(categoryIds: string[], wantedCategory: string) {
  return categoryIds.includes(wantedCategory);
}

function getPackagesString(productPackages: number, unit: string): string {
  return `${
    unit === 'Mks'
      ? (productPackages as number).toFixed(3)
      : productPackages.toString()
  } ${unit}`;
}

function findCategoryIdFromArray(categoryIds: string[]) {
  if (categoryIds.includes('CENTRUM_VYKUROV')) {
    return 'CENTRUM_VYKUROV';
  }

  if (categoryIds.includes('PRE_DREVAROV')) {
    return 'PRE_DREVAROV';
  }

  if (categoryIds.includes('OSTATNE')) {
    return 'OSTATNE';
  }

  return 'SPOJ_MATERIAL';
}

export {
  getZemplinProductDefaultInfo,
  getElasticCategoryZemplinProductInfo,
  getZemplinCartProductInfo,
  getZemplinTrueCount,
  getCorrectPackageNumber,
  getZemplinRequestDetailItemInfo,
  isOrderingLessThanMinimum,
  getZemplinTrueCountFromNormalCount,
  getZemplinCartSummaryInfo,
  shouldShowPriceIfNotOnStock,
  isCategory,
  isSpojMatOrPreDrev,
  resolveIsVykurovaciaOrPletiva,
  findCategoryIdFromArray,
  getPackagesString,
  showWholePackagesOnlyWarning,
  getCountSetterColor,
};
